import React from 'react';
import { Star } from 'lucide-react';
import { motion } from 'framer-motion';
const reviews = [{
  name: 'Marcus R.',
  image: 'https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=100&h=100&fit=crop&crop=face',
  text: 'Le pregunté sobre mi carrera y me dijo exactamente cuándo iba a llegar una oportunidad. Dos semanas después, recibí la oferta. El timing fue exacto.'
}, {
  name: 'Jennifer W.',
  image: 'https://images.unsplash.com/photo-1534528741775-53994a69daeb?w=100&h=100&fit=crop&crop=face',
  text: 'Me dijo que mi alma gemela iba a aparecer cuando menos lo esperara. Tres meses después, conocí a mi esposo en una cafetería. Todavía no puedo creerlo.'
}, {
  name: 'Sofía M.',
  image: 'https://images.unsplash.com/photo-1517841905240-472988babdf9?w=100&h=100&fit=crop&crop=face',
  text: 'Le pedí protección contra mi ex y en menos de un mes, desapareció completamente de mi vida. Como si nunca hubiera existido.'
}, {
  name: 'David C.',
  image: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=100&h=100&fit=crop&crop=face',
  text: 'Me ayudó a conectar con mi abuela que falleció. Los detalles que me dio eran imposibles de saber. Lloré durante una hora.'
}, {
  name: 'Ryan T.',
  image: 'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=100&h=100&fit=crop&crop=face',
  text: 'Tenía miedo de comprometerme con mi pareja. Su lectura me mostró exactamente lo que necesitaba ver. Hoy estamos comprometidos.'
}, {
  name: 'Amanda F.',
  image: 'https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?w=100&h=100&fit=crop&crop=face',
  text: 'La sanación energética que hizo cambió mi vida. Dormí bien por primera vez en meses. Me siento como una persona completamente nueva.'
}];
export function AdditionalReviews() {
  return <section className="w-full py-20 px-4 bg-[#0a0a0a]" data-id="element-47">
      <div className="max-w-6xl mx-auto" data-id="element-48">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-49">
          {reviews.map((review, idx) => <motion.div key={idx} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: idx * 0.1
        }} className="bg-[#111] border border-white/5 p-6 sm:p-8 rounded-2xl hover:border-[#D4AF37]/30 transition-colors flex flex-col" data-id="element-50">
              <div className="flex items-center gap-3 mb-4" data-id="element-51">
                <img src={review.image} alt={review.name} className="w-10 h-10 rounded-full object-cover border border-white/10" data-id="element-52" />
                <div data-id="element-53">
                  <p className="font-playfair text-white font-semibold" data-id="element-54">
                    {review.name}
                  </p>
                  <div className="flex gap-0.5" data-id="element-55">
                    {[1, 2, 3, 4, 5].map(star => <Star key={star} className="w-3 h-3 fill-[#D4AF37] text-[#D4AF37]" data-id="element-56" />)}
                  </div>
                </div>
              </div>
              <p className="font-inter text-gray-300 text-sm leading-relaxed flex-grow" data-id="element-57">
                "{review.text}"
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}